import angular from 'angular';
import payrollComponent from './payroll.component';

let payrollModule = angular.module('payroll', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('payroll', payrollComponent);

export default payrollModule;



// WEBPACK FOOTER //
// ./client/pages/admin/payroll/payroll.js